import { globalCss } from "srs.sharedcomponents/lib/esm/styles";

export const globalStyles = globalCss({
  "*": {
    border: "none",
    padding: 0,
    margin: 0,
  },
  a: {
    color: "inherit",
  },
  '.fa': {
    fontFamily: 'FontAwesome !important',
  },
  '#footerYourPrivacyChoices::after': {
    content: '""',
    display: 'inline-block',
    width: '30px',
    height: '14px',
    marginLeft: '6px',
    verticalAlign: 'middle',
    backgroundImage: 'url("/images/ccpa-icon-ford_275x132.png")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
  },
  // The global "*" reset above strips the OneTrust close/cross buttons, so restore them explicitly.
  '#onetrust-pc-sdk .ot-close-icon, #onetrust-banner-sdk .ot-close-icon, #onetrust-pc-sdk #close-pc-btn-handler, #onetrust-banner-sdk #onetrust-close-btn-container button':
  {
    display: 'block !important',
    visibility: 'visible !important',
    opacity: '1 !important',
    width: '44px',
    height: '44px',
    backgroundColor: 'transparent',
    backgroundRepeat: 'no-repeat !important',
    backgroundPosition: 'center !important',
    backgroundSize: '12px !important',
    cursor: 'pointer',
  },
});
